<list-view *ngIf="listeZu" [liste]="listeZu"></list-view>
<form autocomplete="off" #form="ngForm" *ngIf="prestation">
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.zu.zonesComplementaires.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelleField1"
                                  name="libelleField1"
                                  [(ngModel)]="prestation.libelleField1"
                                  customType="input"
                                  maxlength="20"
                                  libelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ1">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="field1Obligatoire"
                                  name="field1Obligatoire"
                                  [ngModel]="prestation.field1Obligatoire"
                                  [(customModel)]="prestation.field1Obligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ1Obligatoire.title"
                                  postLibelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ1Obligatoire.libelle">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelleField2"
                                  name="libelleField2"
                                  [(ngModel)]="prestation.libelleField2"
                                  customType="input"
                                  maxlength="20"
                                  libelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ2">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="field2Obligatoire"
                                  name="field2Obligatoire"
                                  [ngModel]="prestation.field2Obligatoire"
                                  [(customModel)]="prestation.field2Obligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ2Obligatoire.title"
                                  postLibelle="admin.frais.prestations.detail.zu.zonesComplementaires.champ2Obligatoire.libelle">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</form>